import "./index.scss";

export const FormInput = ({
  label,
  name,
  id,
  inputClassName = "",
  labelClassName = "",
  placeholder = "",
  value,
  onInput,
  type = "text",
  required = true,
  startAdornment = null,
  endAdornment = null
}) => {
  return (
    <>
      {!!label && (
        <label
          htmlFor={id}
          className={`form-input-label ${labelClassName}`}
          data-testid={`${id}-form-label`}
        >
          {label} {required && <abbr title="required">*</abbr>}
        </label>
      )}
      <div className="input-container">
        {!!startAdornment && (
          <div className="start-adornment-area">{startAdornment}</div>
        )}
        <input
          autoComplete="off"
          className={`form-input ${inputClassName}`}
          id={id}
          name={name}
          onInput={(e) => onInput(e.target.value)}
          placeholder={placeholder}
          type={type}
          value={value}
          required={required}
        />
        {!!endAdornment && (
          <div className="end-adornment-area">{endAdornment}</div>
        )}
      </div>
    </>
  );
};
